module.exports = __webpack_public_path__ + "img/product-iron-on-pers.1ca12ca1.png";